// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Types
import Style from "types/globals/styleguide/style";

interface ButtonContainerProps {
  margin: number;
}

const ButtonContainer = styled.div<ButtonContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  margin: auto;
  margin-top: ${({ margin }) => margin}px;
  background-color: transparent;
`;

interface StandardButtonProps {
  color: string;
  backgroundcolor: string;
}

const StandardButton = styled.button<StandardButtonProps>`
  display: flex;
  border: ${({ color }) => "1px solid " + color};
  width: 100%;
  padding: 10px 0;
  max-width: 500px;
  transition: 0.67s;
  text-decoration: none;
  
  color: ${({ color }) => color};
  background-color: ${({ backgroundcolor }) => backgroundcolor};

  text-wrap: balance;

  pointer-events: all !important;
  user-select: auto !important;
  cursor: pointer !important;

  justify-content: center;
  align-items: center;
  text-align: center;

  :hover {
    background-color: ${({ color }) => color} !important;
    color: ${({ backgroundcolor }) => backgroundcolor} !important;
    border: ${({ backgroundcolor }) => "1px solid " + backgroundcolor};
  }
`;

export default StandardButton;

export { ButtonContainer, StandardButton };
